import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Model } from 'src/app/shared/models/clux/model-legacy';

@Component({
  selector: 'app-sign-up-federated-modal',
  templateUrl: 'sign-up-federated-modal.component.html',
  styleUrls: ['./sign-up-federated-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SignUpFederatedModalComponent {
  public dialog = inject(MatDialog);
  public data = inject<Model.MatDialogModel>(MAT_DIALOG_DATA);
  private modalRef = inject<MatDialogRef<SignUpFederatedModalComponent>>(MatDialogRef);

  private identityProvider: string;

  public close(): void {
    this.modalRef.close();
  }
}
